// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2oHWB","title":"Info_title__5oxl9","links":"Info_links__3I61b","link":"Info_link__2llAe","logo":"Info_logo__12SjS"};